/** Only transaction endpoints should exist in constants.ts */
export const GENERATE_SIGN_IN_TXN_ENDPOINT = "/user/sign_in";

export const ROUTE_LOAN_LUT = "/luts/loan";

export const TXN_CREDITBOOK_CREATE = "/creditbook/create";
export const TXN_CREDITBOOK_REFINANCE = "/creditbook/refinance";
export const TXN_CREDITBOOK_BORROW = "/creditbook/borrow";
export const TXN_CREDITBOOK_REPAY = "/creditbook/repay";
export const TXN_CREDITBOOK_DEPOSIT_COLLATERAL = "/creditbook/collateral/deposit";
export const TXN_CREDITBOOK_WITHDRAW_COLLATERAL = "/creditbook/collateral/withdraw";
export const TXN_CREDITBOOK_SWAP_COLLATERAL = "/creditbook/swap_collateral";
export const TXN_CREDITBOOK_MERGE_LOAN = "/creditbook/merge_loan";
export const TXN_CREDITBOOK_MANAGE_COLLATERAL_ORCA_CLAIM_FEES = "/creditbook/collateral/orca/claim_fees";
export const TXN_CREDITBOOK_MANAGE_COLLATERAL_ORCA_UPDATE_LIQUIDITY = "/creditbook/collateral/orca/update_liquidity";
export const TXN_CREDITBOOK_MANAGE_COLLATERAL_ORCA_UPDATE_POSITION = "/creditbook/collateral/orca/transfer_position";
export const TXN_CREDITBOOK_BUILD_LOAN = "/creditbook/build";
export const TXN_CREDITBOOK_LENDER_BUILD = "/creditbook/lend/build_loopscale";

//Raydium
export const TXN_CREDITBOOK_MANAGE_RAYDIUM_LIQUIDITY = "/creditbook/collateral/raydium/update_liquidity";
export const TXN_CREDITBOOK_TRANSFER_RAYDIUM_POSITION = "/creditbook/collateral/raydium/transfer_position";

export const TXN_LEND_VAULT_CANCEL_TIMELOCKS = "/lending_vaults/timelock/cancel";
export const TXN_LEND_VAULT_CREATE_TIMELOCKS = "/lending_vaults/timelock/create";
export const TXN_LEND_VAULT_DEPOSIT = "/lending_vaults/deposit";

export const TXN_LEND_VAULT_WITHDRAW = "/lending_vaults/withdraw";
export const TXN_LEND_VAULT_EDIT_DEPOSITS = "/lending_vaults/deposits/edit";
export const TXN_LEND_VAULT_CLAIM_FEE = "/lending_vaults/fee/claim";
export const TXN_LEND_VAULT_MINT_LP_IXS = "/lending_vaults/ix/mint_lp";
export const TXN_LEND_VAULT_CREATE_REWARDS = "/lending_vaults/rewards/schedule/create";
export const TXN_LEND_VAULT_EDIT_REWARDS = "/lending_vaults/rewards/schedule/edit";
export const TXN_LEND_VAULT_CLAIM_REWARDS = "/lending_vaults/rewards/claim";

export const TXN_EARN_VAULT_DEPOSIT = "/earn/vaults/deposit/tx";
export const TXN_EARN_VAULT_WITHDRAW_REQUEST = "/earn/vaults/withdraw_request/tx";
export const TXN_EARN_VAULT_WITHDRAW_CLAIM = "/earn/vaults/withdraw_claim/tx";
export const TXN_EARN_VAULT_WITHDRAW_CANCEL = "/earn/vaults/withdraw_cancel/tx";

export const TXN_FLASH_BORROW = "/creditbook/flash_borrow";
// loop unwind uses repay

export const TXN_STRATEGY_CREATE = "/strategy/create";
export const TXN_STRATEGY_DEPOSIT = "/strategy/deposit";
export const TXN_STRATEGY_WITHDRAW = "/strategy/withdraw";
export const TXN_STRATEGY_UPDATE = "/strategy/update";
export const TXN_STRATEGY_CLOSE = "/strategy/close";

export const TXN_LOCKBOX_CREATE = "/lockbox/create";
export const TXN_LOCKBOX_DEPOSIT = "/lockbox/deposit";
export const TXN_LOCKBOX_WITHDRAW = "/lockbox/withdraw";
export const TXN_LOCKBOX_LOCK = "/lockbox/lock";
export const TXN_LOCKBOX_UNLOCK = "/lockbox/unlock";
export const TXN_LOCKBOX_CLOSE = "/lockbox/close";
